'use strict';

angular.module('licensure.services')
    .factory('AlertTypes', ['$http', '$q', function ($http, $q) {
        return {
            get: function () {
                var d = $q.defer();
                $http
                    .get(apiLocation + '/api/alerttypes', {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                        d.reject(response.data);
                    });

                return d.promise;
            }
        }
    }])
;